/* eslint-disable  import/prefer-default-export */
export const redirect = (location: string) => {
  window.location.href = location;
};
